import React from "react";
import { gsap } from "gsap";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import styles from "./BonusPrize.module.scss";
import choice from "../../img/bonusPrize/choice.png";
import most from "../../img/bonusPrize/most.png";
import best from "../../img/bonusPrize/best.png";
import trophy from "../../img/bonusPrize/trophy.png";
const BonusPrize = ({ bonusPrizeRef }) => {
  const firstTrophyRef = useRef();
  const secondTrophyRef = useRef();
  const thirdTrophyRef = useRef();

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add(
        "(min-width:1441px)",
        () => {
          gsap.fromTo(
            firstTrophyRef.current,
            {
              top: "-100px",
              duration: 2,
            },
            {
              top: "-34px",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "top 70%",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 2,
            }
          );
        },
        firstTrophyRef
      );
      gsap.matchMedia().add(
        "(min-width:769px) and (max-width:1440px)",
        () => {
          gsap.fromTo(
            firstTrophyRef.current,
            {
              top: "-14vw",
            },
            {
              top: "-2.36vw",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "top 75%",
                end: "center cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        firstTrophyRef
      );
      gsap.matchMedia().add(
        "(min-width:481px) and (max-width:768px)",
        () => {
          gsap.fromTo(
            firstTrophyRef.current,
            {
              top: "0vw",
            },
            {
              top: "26.3vw",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "-10% top",
                end: "10% cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        firstTrophyRef
      );

      gsap.matchMedia().add(
        "(max-width:480px)",
        () => {
          gsap.fromTo(
            firstTrophyRef.current,
            {
              top: "0vw",
            },
            {
              top: " 50vw",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "-10% 30%",
                end: "10% cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        firstTrophyRef
      );
    });
    return () => ctx.revert();
  });

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add(
        "(min-width:1441px)",
        () => {
          gsap.fromTo(
            secondTrophyRef.current,
            {
              top: "200px",
              duration: 2,
            },
            {
              top: "354px",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "center 70%",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 2,
            }
          );
        },
        secondTrophyRef
      );
      gsap.matchMedia().add(
        "(min-width:769px) and (max-width:1440px)",
        () => {
          gsap.fromTo(
            secondTrophyRef.current,
            {
              top: "13.89vw",
            },
            {
              top: "24.58vw",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "top 75%",
                end: "center cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        secondTrophyRef
      );
    });
    return () => ctx.revert();
  });

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add(
        "(min-width:1441px)",
        () => {
          gsap.fromTo(
            thirdTrophyRef.current,
            {
              bottom: 0,
              duration: 2,
            },
            {
              bottom: "78.66px",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "center 60%",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 2,
            }
          );
        },
        thirdTrophyRef
      );
      gsap.matchMedia().add(
        "(min-width:769px) and (max-width:1440px)",
        () => {
          gsap.fromTo(
            thirdTrophyRef.current,
            {
              bottom: "0vw",
            },
            {
              bottom: "5.46vw",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "center 60%",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        thirdTrophyRef
      );
      gsap.matchMedia().add(
        "(min-width:481px) and (max-width:768px)",
        () => {
          gsap.fromTo(
            thirdTrophyRef.current,
            {
              bottom: "-5vw",
            },
            {
              bottom: "5.73vw",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "70% 60%",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        thirdTrophyRef
      );

      gsap.matchMedia().add(
        "(max-width: 480px)",
        () => {
          gsap.fromTo(
            thirdTrophyRef.current,
            {
              bottom: "-10vw",
            },
            {
              bottom: "3.33vw",
              scrollTrigger: {
                trigger: bonusPrizeRef.current,
                start: "70% 60%",
                end: "bottom center",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        thirdTrophyRef
      );
    });
    return () => ctx.revert();
  });
  return (
    <div className={styles.container} ref={bonusPrizeRef}>
      <div className={styles.contents_box}>
        <img src={trophy} alt="" ref={firstTrophyRef} />
        <img src={trophy} alt="" ref={secondTrophyRef} />
        <img src={trophy} alt="" ref={thirdTrophyRef} />
        <h1 data-content="Bonus Prizes!">Bonus Prizes!</h1>
        <div className={styles.bonus_contents}>
          <div>
            <img src={choice} alt="" />
            <p>MondayOFF’s Choice</p>
          </div>
          <div>
            <img src={most} alt="" />
            <p>Most Unique</p>
          </div>
          <div>
            <img src={best} alt="" />
            <p>Best Hybrid</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BonusPrize;
